import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  alumniSurvey: {
    height: '84vh',
    width: '100% !important',
    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '80vh',
    },
    '@media (min-width: 480px) and (max-width: 600px)': {
      height: '80vh',
    },

  },
  alumniSurveyContainer: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: '26px 0px 26px 20px',
    width: '100%',
    height: '83.5vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '80.8vh',
    },
    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '68vh !important',
      padding: "26px 0px 26px 17px",
    },
    '@media (min-width: 480px) and (max-width: 600px)': {
      height: '47vh !important',
      padding: "26px 0px 26px 17px"
    },
  },
  alumniSurveyContainerMobile: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: "26px 0px 26px 17px",
    width: '100%',
    height: 'auto',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '80.8vh',
    },
    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '68vh !important',
      padding: "26px 0px 26px 17px",
    },
    '@media (min-width: 480px) and (max-width: 600px)': {
      height: '47vh !important',
      padding: "26px 0px 26px 17px"
    },
  },
  alumniSurveyContainerMobile1: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: "26px 0px 26px 17px",
    width: '100%',
    height: '83vh',

    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '80vh !important',
      padding: "26px 0px 26px 17px",
    },
    '@media (min-width: 480px) and (max-width: 600px)': {
      height: '80vh !important',
      padding: "26px 0px 26px 17px"
    },
  },
  sectionTitle1: {
    textAlign: 'left',
    fontSize: '16px ',
    fontWeight: '500 !important',
    marginBottom: '10px !important',
  },
  alumniCreateSurveyContainer: {
    boxShadow: 'none !important',
    borderRadius: '16px !important',
    width: '100%',
    height: '60%',
  },
  alumniCreateSurveyContainerTitle: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    textAlign: 'start',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
      fontWeight: '600 !important',
    },
  },
  alumniCreateSurveyContainerTitleBorder: { background: 'linear-gradient(90deg, #BFCEFF 0%, #BFCEFF00 100%);', height: '1px', marginTop: '4px' },
  alumniCreateSurveyContainerBody: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '50px !important' },
  beginSurveyImg: {
    height: '292.36px !important',
    width: '311.45px !important',
    userSelect: 'none',
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: '92.36px !important',
      width: '100.45px !important',
    },
  },
  alumniCreateSurveyContainerBodyTitle: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
  },
  alumniCreateSurveyContainerBodyDescription: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    paddingInline: '50px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  beginSurveyButton: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#fff !important',
    marginTop: '25px !important',
    boxShadow: 'none !important',
    borderRadius: '8px !important',
    background: '#2C60AA !important',
    padding: '20px !important',
    height: '36px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '28px !important',
    },
  },
  beginSurveyButton1: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: 'white !important',
    boxShadow: 'none !important',
    borderRadius: '8px !important',
    background: '#2C60AA !important',
    padding: '20px !important',
    height: '36px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '20px !important',
      padding: '10px !important',
    },
    '@media (min-width: 280px) and (max-width: 600px)': {
      padding: '10px !important',
    },
  },

  //   create survey styles
  formFooter: {
    display: 'flex',
    justifyContent: 'end',
    gap: '20px',
    borderTop: `1px solid ${theme.palette.KenColors.ClientDivider}`,
    paddingTop: '20px',
  },
  cardContainerForm: {
    boxShadow: 'none !important',
    textAlign: 'start',
    borderRadius: '9px !important',
    padding: '20px',
    height: '83.5vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '80.5vh',
    },
    '@media (min-width: 280px) and (max-width: 400px)': {
      height: '81.5vh',
      padding: '5px 16px',
    },
    '@media (min-width: 400px) and (max-width: 600px)': {
      height: '83.5vh',
      padding: '5px 16px',
    },
  },
  pageHeader: {
    fontSize: '15px !important',
    fontWeight: '550 !important',
    color: theme.palette.KenColors.ClientBlack2,
    padding: '10px 0px 10px 0px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  gridContainer: {
    height: '63vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (min-width: 1270px) and (max-width: 1290px)': {
      height: '58vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh !important',
    },
  },

  // SurveyDialog
  profileButton: {
    display: 'flex !important',
    borderRadius: '6px !important',
    boxShadow: 'none !important',
  },
  dilogHeader: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    marginBottom: '12px !important',
    borderBottom: '2px solid #BFCEFF',
    paddingBottom: '10px',
  },
  dilogtypo: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    marginBottom: '8px !important',
  },
  customSelect: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '0px 12px !important',
      borderRadius: '12px !important',
    },
    '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
      padding: '10px !important',
    },
  },
  customTextArea: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '10px 12px !important',
      borderRadius: '12px !important',
      textAlign: 'center !important',
    },
  },
  customText: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '0px 12px !important',
      borderRadius: '12px !important',
      textAlign: 'center !important',
    },
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      padding: '10px !important',
    },
  },
  alumiBox: {
    height: '55vh',
    [theme.breakpoints.up('xxl')]: {
      height: '68vh',
    },
  },
  alumiBox2: {
    height: '75vh',
    [theme.breakpoints.up('xxl')]: {
      height: '68vh',
    },
  },
  alumiBox1: {
    height: '65vh',
    [theme.breakpoints.up('xxl')]: {
      height: '72vh',
    },
    '@media (min-width: 1536px) and (max-width: 1600px)': {
      height: '75vh',
    },
    '@media (min-width: 336px) and (max-width: 600px)': {
      height: '50vh',
    },
  },
  horizontalLine: {
    height: '58vh',
    backgroundColor: '#E5E6EA',
    width: '1px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh !important',
    },
  },
}));
